// const TranslationAccountOrder = async (data) => {
//   const returnOr = document.querySelector('.customer-order__right__return');
//   const orderProp = document.querySelectorAll('.order-property p');
//   const orderPropA = document.querySelector('.order-property a');

//   orderProp[0].textContent = ;
//   orderProp[1].textContent.replace('at', data[3]["YG"]);
//   orderPropA.textContent = ;
// };

function TransActivate(data) {
  const pass = document.querySelector('.activate_Pass');
  const passC = document.querySelector('.activate_PassC');
  pass.textContent = data[18]["pass"];
  passC.textContent = data[18]["passC"];
};

function TranslationReviewInMP(data) {
  const revFirstButton = document.querySelector('.jdgm-write-rev-link');
    
    if (revFirstButton) {
    revFirstButton.addEventListener('click', () => {
      
      setTimeout(() => {
      const revSendButton = document.querySelector('.jdgm-submit-rev');
         
        revSendButton.addEventListener('click', () => {
          
      setTimeout(() => {        
        const revTitle = document.querySelector('.jdgm-notification__title');
        
        revTitle.textContent = data[6]["Rmess"];
        },500);
          });
    },500);
    });
    }
}

const TranslationCollection = async (data) => { 

  const loadMore = document.querySelector('.catalog__load-more.catalog__load-more_button');
  const loadingB = document.querySelector('.catalog__load-more_loading');
  
  if(loadMore) {
    loadMore.textContent = data[11]["LM"];
  }
  if (loadingB) {
    loadingB.textContent = data[11]["Loading"];
  }
  
};
const TranslationSearch = async (data) => { 
  const searchP = document.querySelector('.search-pages .searchTitle');
  const search = document.querySelector('.search-header .searchTitle');
  const searchMobile = document.querySelector('.search-header .mobile');
  const topTitle = document.querySelector('.top-image__title'); 
  const searchResults = document.querySelector('.search-results p');
  const variantsSearch = document.querySelectorAll('.search-results .productShadess');
  if (variantsSearch.length > 0) {
  variantsSearch.forEach((variant) => {
    if (variant.textContent === 'SHADES') {
      variant.textContent = data[4]["SHADES"];
    } else if (variant.textContent === 'SIZES') {
      variant.textContent = data[4]["SIZES"];
    } else {
      
    }
  });
  }

  if (searchP) {
    searchP.textContent = data[0]["searchP"];
  }
  if (search) {
    search.textContent = data[0]["search"];
  }
  if (searchMobile) {
    searchMobile.textContent = data[0]["searchMobile"];
  }
  if (topTitle) {
    topTitle.textContent = data[0]["searchMobile"];
  }
  if (searchResults) {
  if (searchResults.textContent === 'Nothing found for your request.') {
    searchResults.textContent = data[0]["searchResults"];
  }
  }
};

const TranslationContactPage = async (data) => {
  const title = document.querySelector('.contact-form__header');
  const descript = document.querySelector('.contact__text-blocks p');
  if (title) {
        title.textContent  = data[17]["title"];
  }
  if (descript) {
  descript.textContent  = data[17]["descript"];
  }
}
const TranslationAccount = async (data) => {   
    console.log('test -data', data);
        const lecErcle0 = await Promise.resolve(document.querySelectorAll('.customers_account__near form'));
        console.log('lecErcle0', lecErcle0);
        console.log('lecErcle0[0]', lecErcle0[0]);                
        const nameS = lecErcle0[0].querySelector('.cf-field p');
        console.log('nameS', nameS);
        const labels = lecErcle0[0].querySelectorAll('label');
        const selects = lecErcle0[0].querySelectorAll('select');
        const button = lecErcle0[0].querySelector('button');
        const allOptions = [];
        const changP = document.querySelector('.con-sub__reset_customer_password .cf-submit-form'); 
        const secG = document.querySelectorAll('.customers_account__order2__near h2')[1];
        
        selects.forEach(select => {
          const options = select.querySelectorAll('option');
          allOptions.push(...options);
        });

        const form2Labels = lecErcle0[1].querySelectorAll('label');
        
        const form2Data = lecErcle0[1].querySelector('.edit-form-text');
        const button2 = lecErcle0[1].querySelector('button');
  
       //* const topt = document.querySelector('.top-image__title');
        const mobileTopt = document.querySelector('.my-account-header');
        const tabs = document.querySelectorAll('.myAccountMenu__tabs a');
        const grayBH2 = document.querySelector('.customers_account__order2__near h2');
        const grayBp = document.querySelector('.customers_account__order2__near p');
        const grayBp2 = document.querySelectorAll('.customers_account__order2__near p');
        const grayBa = document.querySelectorAll('.customers_account__order2__near a');
  const logOut = document.querySelectorAll('.customers_account__a');
        const accSpan = document.querySelector('.account-points .left h1 span');
        const p1 = document.querySelector('.account-points .p1');
        const p2 = document.querySelector('.account-points .p2');
        const accA = document.querySelector('.account-points .left a');
  const accRight = document.querySelector('.account-points .right h1');
  const accRightp = document.querySelector('.account-points .right p');
  const accRightpints = document.querySelector('.accPoints');
  const header2 = document.querySelectorAll('.header2');
  const subss = document.querySelector('.cf-field h1');
  const transRegButtons = document.querySelectorAll('.transReg');
  const mobileChangePass = document.querySelectorAll('.con-sub__reset_customer_password .cf-submit-form');

  secG.textContent = data[0]["grayBH2"];
  grayBp2[1].innerHTML = data[0]["grayBp"];
  grayBa[2].textContent = data[0]["grayBa0"];
  grayBa[3].textContent = data[0]["grayBa1"];

  // if (!subss) {
  //   setTimeout(() => {
  //     console.log('inTimeoutBeforeFunction');
  //     TranslationAccount(data);
  //   },1000);
    
  //   return;
  // }
  // subss.textContent = data[0]["subs"];
  changP.textContent = data[0]["changP"];
 //* topt.textContent = data[0]["topt"];
  if (mobileTopt) {
    mobileTopt.textContent = data[0]["topt"];
  }
  if (mobileChangePass[1]) {
    mobileChangePass[1].textContent = data[0]["changP"];
  }
  tabs[0].textContent = data[0]["tabs0"];
  tabs[1].textContent = data[0]["tabs1"];
  tabs[2].textContent = data[0]["tabs2"];
  tabs[3].textContent = data[0]["tabs3"];
  grayBH2.textContent = data[0]["grayBH2"];
  grayBp.innerHTML = data[0]["grayBp"];
  grayBa[0].textContent = data[0]["grayBa0"];
  grayBa[1].textContent = data[0]["grayBa1"];
  logOut.forEach((trans) => {
    trans.textContent = data[0]["grayBa2"];
  }); 
  accSpan.textContent = data[0]["accSpan"];
  p1.textContent = data[0]["p1"];
  p2.textContent = data[0]["p2"];
  accA.textContent = data[0]["accA"];
  accRight.textContent = data[0]["accRight"];
  if (accRightp.textContent === '') {    
  } else if (accRightp.textContent === 'Platinum') {
    accRightp.textContent = data[0]["Platinum"];
  } else if (accRightp.textContent === 'Gold') {
    accRightp.textContent = data[0]["Gold"];
  } else if (accRightp.textContent === 'Silver') {
    accRightp.textContent = data[0]["Silver"];
  } else if (accRightp.textContent === 'Bronze') {
    accRightp.textContent = data[0]["Bronze"];
  };
  accRightpints.textContent = data[0]["accRightpints"];
  header2[0].textContent = data[0]["header0"];
  header2[1].textContent = data[0]["header1"];
  header2[2].textContent = data[0]["header2"];
  header2[3].textContent = data[0]["header3"];
console.log('BeforeFunction');
  
  if (!nameS) {
    setTimeout(() => {
      console.log('inTimeoutBeforeFunction');
      TranslationAccount(data);
    },1000);
    
    return;
  }
  console.log('last');
  console.log('nameS-new', nameS);
  nameS.innerHTML = data[0].forms[0]["0"];
            labels[0].textContent = data[0].forms[0]["lable0"];
            labels[1].textContent = data[0].forms[0]["lable1"];
            labels[2].textContent = data[0].forms[0]["lable2"];
            allOptions[0].textContent = data[0].forms[0]["selectOp"];
            allOptions[1].textContent = data[0].forms[0]["options0"][1];
              allOptions[2].textContent = data[0].forms[0]["options0"][2];
              allOptions[3].textContent = data[0].forms[0]["options0"][3];
              allOptions[4].textContent = data[0].forms[0]["options0"][4];
            button.textContent = data[0].forms[0]["button"];
            allOptions[5].textContent = data[0].forms[0]["selectOp"];
            allOptions[6].textContent = data[0].forms[0]["options1"][1];
            allOptions[7].textContent = data[0].forms[0]["options1"][2];
            allOptions[8].textContent = data[0].forms[0]["options1"][3];
            allOptions[9].textContent = data[0].forms[0]["options1"][4];
            allOptions[10].textContent = data[0].forms[0]["options1"][5];
            allOptions[11].textContent = data[0].forms[0]["options1"][6];
            allOptions[12].textContent = data[0].forms[0]["options1"][7];
            allOptions[13].textContent = data[0].forms[0]["options1"][8];
            allOptions[14].textContent = data[0].forms[0]["options1"][9];
            allOptions[15].textContent = data[0].forms[0]["options1"][10];
            allOptions[16].textContent = data[0].forms[0]["options1"][11];
            allOptions[17].textContent = data[0].forms[0]["options1"][12];
            allOptions[18].textContent = data[0].forms[0]["selectOp"];
            allOptions[19].textContent = data[0].forms[0]["options3"][1];
            allOptions[20].textContent = data[0].forms[0]["options3"][2];
            allOptions[21].textContent = data[0].forms[0]["options3"][3];
            allOptions[22].textContent = data[0].forms[0]["options3"][4];
            allOptions[23].textContent = data[0].forms[0]["options3"][5];
            allOptions[24].textContent = data[0].forms[0]["options3"][6];

            form2Labels[0].textContent = data[0].forms[1]["lable0"];
            form2Labels[1].textContent = data[0].forms[1]["lable1"];
            form2Labels[2].textContent = data[0].forms[1]["lable2"];
            form2Labels[3].textContent = data[0].forms[1]["lable3"];
            form2Data.innerHTML = data[0].forms[1]["data"];
             // form2Labels[4].querySelector('span').textContent = data[0].forms[1]["news"];
            button2.textContent = data[0].forms[1]["button"];

 if (transRegButtons.length > 0) {
    
    transRegButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const firstInterval = setInterval(() => {
                
                const messageSucss = document.querySelectorAll('.account-two-forms .cf-fields-container .cf-field h1');
                const messageP = document.querySelectorAll('.account-two-forms .cf-fields-container .cf-field p');
              
                messageSucss.forEach((mess) => {
                    if (mess.textContent === 'Success!') {
                        mess.textContent = data[0]["suc"];
                    }
                });

                messageP.forEach((mess) => {
                    if (mess.textContent === 'The form has been successfully submitted.') {
                        mess.textContent = data[0]["sucText"];
                        if (firstInterval) {
                            clearInterval(firstInterval);
                        }
                    }
                });
              
            }, 1000);
        });
    });
}

    };
const TranslationNewsletter = async (data) => {
  const subTit = document.querySelector('.subscribe-section__Title');
  const subTex = document.querySelector('.subscribe-section__Text');
  const subBut = document.querySelector('#submit_button_contact');
  const subBut2 = document.querySelector('.newsFakeB');
  const subInp = document.querySelector('.subscribe-section__content .input-group-field');
  const subLabl = document.querySelector('.subscribe-section__content .checkbox__text');
const newsErrorM = document.querySelector('.newsErrorM');
  
  if (subTit) {
  subTit.textContent =  data[10]["subTit"];
  subTex.textContent =  data[10]["subTex"];
  if (subBut) { 
    subBut.textContent =  data[10]["subBut"];
    }
    if (subBut2) {
      subBut2.textContent =  data[10]["subBut"];
    }
  if (subInp) {
    subInp.placeholder =  data[10]["subInp"];
  }
  if (subLabl) {
    subLabl.textContent =  data[10]["subLabl"];
  }
     if (newsErrorM) {
      newsErrorM.textContent =  data[18]["NewsLCheckBox"];
    }
  }
};
  
const TranslationMyOrders = async (data) => {                
          
        //*const topt = document.querySelector('.top-image__title');
  const mobileTopt = document.querySelector('.my-account-header');
        const tabs = document.querySelectorAll('.myAccountMenu__tabs a');
        const grayBH2 = document.querySelector('.customers_account__order2__near h2');
        const grayBp = document.querySelector('.customers_account__order2__near p');
        const grayBa = document.querySelectorAll('.customers_account__order2__near a');
  const logOut = document.querySelectorAll('.customers_account__a');
  const tHello = document.querySelector('.needClass span');
  const textT = document.querySelector('.my-oders__text-p');
  const invoce = document.querySelector('.my-oders__under-div__1column-idk .table');

  if (textT) {
    textT.textContent = data[0]["oText"];
  }

  tHello.textContent = data[0]["tHello"];
 //*  topt.textContent = data[0]["topt"];
  if (mobileTopt) {
    mobileTopt.textContent = data[0]["topt"];
  }
  tabs[0].textContent = data[0]["tabs0"];
  tabs[1].textContent = data[0]["tabs1"];
  tabs[2].textContent = data[0]["tabs2"];
  tabs[3].textContent = data[0]["tabs3"];
  grayBH2.textContent = data[0]["grayBH2"];
  grayBp.innerHTML = data[0]["grayBp"];
  grayBa[0].textContent = data[0]["grayBa0"];
  grayBa[1].textContent = data[0]["grayBa1"];
  logOut.forEach((trans) => {
    trans.textContent = data[0]["grayBa2"];
  });

  invoce.textContent = data[0]["Invoice"];
    };

const TranslationWishlist = async (data) => {                
          
      //*   const topt = document.querySelector('.top-image__title');
        const tabs = document.querySelectorAll('.myAccountMenu__tabs a');
        const grayBH2 = document.querySelector('.customers_account__order2__near h2');
        const grayBp = document.querySelector('.customers_account__order2__near p');
        const grayBa = document.querySelectorAll('.customers_account__order2__near a');
        const logOut = document.querySelectorAll('.customers_account__a');
        const mobileTopt = document.querySelector('.my-account-header');
        const tHello = document.querySelector('.needClass span');

  const searchButtonInterval = setInterval(() => {
    const zooomybtnA = document.querySelectorAll('.zooomybtn a');
    if (zooomybtnA.length > 0) {
      clearInterval(searchButtonInterval);
      zooomybtnA.forEach((viewCB) => {
        viewCB.textContent = data[0]["wishList"]["viewP"];
      })
    }
  },300);

 tHello.textContent = data[0]["tHello"];
 //*  topt.textContent = data[0]["topt"];
  if (mobileTopt) {
    mobileTopt.textContent = data[0]["topt"];
  }
  tabs[0].textContent = data[0]["tabs0"];
  tabs[1].textContent = data[0]["tabs1"];
  tabs[2].textContent = data[0]["tabs2"];
  tabs[3].textContent = data[0]["tabs3"];
  grayBH2.textContent = data[0]["grayBH2"];
  grayBp.innerHTML = data[0]["grayBp"];
  grayBa[0].textContent = data[0]["grayBa0"];
  grayBa[1].textContent = data[0]["grayBa1"];
  logOut.forEach((trans) => {
    trans.textContent = data[0]["grayBa2"];
  });
    setTimeout(async () => {
    const zmsg = document.querySelector('.zmsg');
    const addcartbtn = document.querySelectorAll('.addcartbtn');
    if (addcartbtn.length > 0) {
      addcartbtn.forEach((button) => {
        button.textContent = data[0]["wishList"]["addToCart"];
        button.addEventListener('click', () => {
            setTimeout(async () => {
              button.textContent = data[0]["wishList"]["inCart"];
              },1500);
        });
      });
    // const wishButInterval =  setinterval = (() => {
    //       const addcartbtn = document.querySelectorAll('.addcartbtn');
    //   if (addcartbtn.length > 0) {
    //     addcartbtn.forEach((button) => {
    //       if (button.textContent)
    //     });
    //   }
    //   },500);
      
    } else if (zmsg) {
    zmsg.textContent = data[0]["wishList"]["zmsg"];
  }
      const zooomyshopvariantLang = document.querySelectorAll('.zooomyshopvariant');
      if (zooomyshopvariantLang.length > 0 ) {
    zooomyshopvariantLang.forEach(select => {
    select.addEventListener('change', function() {
        setTimeout(() => {
          const addcartbtn = document.querySelectorAll('.addcartbtn');
          if (addcartbtn.length > 0) {
      addcartbtn.forEach((button) => {
        button.textContent = data[0]["wishList"]["addToCart"];
        button.addEventListener('click', () => {
            setTimeout(async () => {
              button.textContent = data[0]["wishList"]["inCart"];
              },1500);
        });
      });      
    }
          
        },300);
      
    });
});
    }
  },4000);
  
  setInterval(() => {
const forAddedToCart = document.querySelectorAll('.zooomybtn'); 
    if (forAddedToCart.length > 0) {
  forAddedToCart.forEach((button) => {
    if (button && button.textContent === 'Item is added to cart.') {
      button.textContent = data[0]["wishList"]["inCart"];
    }
  });
  }
        },500);
    };

const TranslationAddress = async (data) => {                
          
       //* const topt = document.querySelector('.top-image__title');
        const tabs = document.querySelectorAll('.myAccountMenu__tabs a');
        const grayBH2 = document.querySelector('.customers_account__order2__near h2');
        const grayBp = document.querySelector('.customers_account__order2__near p');
        const grayBa = document.querySelectorAll('.customers_account__order2__near a');
        const logOut = document.querySelectorAll('.customers_account__a');
        const addAd = document.querySelector('.button-natural__addresses');
  if (addAd) {
        const modify = document.querySelectorAll('.button__Modify');
        const formAddres = document.querySelector('#AddAddress');
        const formAp = formAddres.querySelectorAll('.field p');
        const tHello = document.querySelector('.tHello');
        const nameElements = document.querySelectorAll('.Modify-form input[name="address[first_name]"]');
        const nameLastElements = document.querySelectorAll('.Modify-form input[name="address[last_name]"]');
  }
    const customerReturn = document.querySelector('.customer-order__right__return');
    const tHello2 = document.querySelector('.needClass span');
  const orderdate = document.querySelector('.orderdate');
  const downloadeInv = document.querySelector('.downloadeInv');
  const orderVar = document.querySelector('.table-orders__tfoot__row__vat');
  const DeliveryOrder = document.querySelector('.DeliveryOrder');
  const TOTALorder = document.querySelector('.TOTALorder');
  const points = document.querySelectorAll('.cart-drawer__loyalty-points')[1];
  const comment = document.querySelectorAll('.cart-drawer__loyalty-comment')[1];
  const bottomblockH2 = document.querySelector('.images-section__h2');
  const bottomblock = document.querySelectorAll('.images-section__grid h3 a');
  const orderCanceled = document.querySelector('.order-cancelled');

if (customerReturn) {
  tHello2.textContent = data[0]["tHello"];
  customerReturn.textContent = data[18]["customerReturn"];
  orderdate.textContent = data[18]["orderdate"];
  downloadeInv.textContent = data[18]["downloadeInv"];
  orderVar.textContent = orderVar.textContent.replace('Including', data[18]["orderVar"]);
  orderVar.textContent = orderVar.textContent.replace('vat', data[18]["orderVar2"]);
  DeliveryOrder.textContent = data[18]["DeliveryOrder"];
  TOTALorder.textContent = data[18]["TOTALorder"];
  points.textContent = points.textContent.replace('Loyalty program:',data[18]["points1"]); 
  points.textContent = points.textContent.replace('points',data[18]["points2"]);
  points.textContent = points.textContent.replace('with this order',data[18]["points3"]); 
  comment.textContent = data[18]["comment"];
  bottomblockH2.textContent = data[18]["bottomblockH2"];
  bottomblock[0].textContent = data[18]["bottomblock1"];
  bottomblock[1].textContent = data[18]["bottomblock2"];
  bottomblock[2].textContent = data[18]["bottomblock3"];
  if (orderCanceled) {
  orderCanceled.textContent = data[18]["orderCanceled"];
  }
}
  const mobileTopt = document.querySelector('.my-account-header');
        if (addAd) {
  nameElements.forEach((editFormInput) => {
    editFormInput.placeholder = data[0]["addAddForm"]["Fn"];
  });

  nameLastElements.forEach((editFormInput) => {
    editFormInput.placeholder = data[0]["addAddForm"]["Ln"];
  }); 
        }
  if (mobileTopt) {
    mobileTopt.textContent = data[0]["topt"];
  }
  if (addAd) {
  tHello.textContent = data[0]["tHello"];
  }
//*m  topt.textContent = data[0]["topt"];
  tabs[0].textContent = data[0]["tabs0"];
  tabs[1].textContent = data[0]["tabs1"];
  tabs[2].textContent = data[0]["tabs2"];
  tabs[3].textContent = data[0]["tabs3"];
  grayBH2.textContent = data[0]["grayBH2"];
  grayBp.innerHTML = data[0]["grayBp"];
  grayBa[0].textContent = data[0]["grayBa0"];
  grayBa[1].textContent = data[0]["grayBa1"];
  logOut.forEach((trans) => {
    trans.textContent = data[0]["grayBa2"];
  });
     if (addAd) {
  addAd.textContent = data[0]["addAddress"]["addAd"];
  console.log('modify', modify);
  console.log('data[0]["addAddress"]["modify"]', data[0]["addAddress"]["modify"]);
  if (modify.length > 0) {
    modify.forEach((button) => {
      console.log('button', button);
      button.textContent = data[0]["addAddress"]["modify"];
    });
  }

  formAp[0].textContent = data[0]["addAddForm"]["Fn"];
  formAp[1].textContent = data[0]["addAddForm"]["Ln"];
  formAp[2].textContent = data[0]["addAddForm"]["AC"];
  formAp[3].textContent = data[0]["addAddForm"]["ad1"];
  formAp[4].textContent = data[0]["addAddForm"]["ad2"];
  formAp[5].textContent = data[0]["addAddForm"]["City"];
  formAp[6].textContent = data[0]["addAddForm"]["Co"];
  formAp[7].textContent = data[0]["addAddForm"]["Po"];
  formAp[8].textContent = data[0]["addAddForm"]["Tel"];
     }
    };

const TranslationRegisterForm = (data) => {
  console.log('registForm');
  const inputsRegForm = document.querySelectorAll('#create_customer input');
  
  const loginToAcc = document.querySelector('.register__bottom.hiddenformobile');
  
  const topt = document.querySelector('.top-image__title');
  const cos = document.querySelector('.header__register');
  const cosText = document.querySelector('.header-with-text p');
  const actionBottom = document.querySelector('.createButton_div');
  const checkBox1 = document.querySelector('.check1');
  const checkBox2 = document.querySelector('.check2');
  const checkBoxError = document.querySelector('.checkBox_error');

  if (checkBoxError) {
    checkBoxError.textContent = data[18]["registrCheckBox"];
  }

  const donthaveacc = document.querySelector('.donthaveacc');
  

  donthaveacc.textContent = data[2]["donthaveacc"];
  
  // if (!regForm) {
  //   setTimemout(() => {
  //     TranslationRegisterForm(data);
  //     return;
  //   },1000);
  // }
    
  checkBox1.innerHTML = data[0]["checkBox1"];
  checkBox2.innerHTML = data[0]["checkBox2"];

  
  
  topt.textContent = data[0]["topt"];
  cos.textContent = data[0]["cos"];
  cosText.textContent = data[0]["cosText"];
  
  inputsRegForm[2].placeholder = data[1]["input0"];
  inputsRegForm[3].placeholder = data[1]["input1"];
  inputsRegForm[4].placeholder = data[1]["input2"];
  
  actionBottom.textContent = data[1]["button"];
  
  loginToAcc.textContent = data[1]["loginToAcc"];
  
};

const TranslationLoginForm = (data) => {

  const loginForm = document.querySelector('#customer_login');
  const inputsLoginForm = document.querySelector('#CustomerEmail');
  const button = loginForm.querySelector('button');
  const RecoverPassword = document.querySelector('#RecoverPassword');
  const loginToAcc = document.querySelectorAll('.register__bottom');
  const text = document.querySelector('.p-bottom__register p');
  const donthaveacc = document.querySelector('.donthaveacc');
  //*const topt = document.querySelector('.top-image__title');
  const cosL = document.querySelector('.header__register');
  const cosTextL = document.querySelector('.header-with-text p');

  donthaveacc.textContent = data[2]["donthaveacc"];
  //*topt.textContent = data[0]["topt"];
  cosL.textContent = data[0]["cosL"];
  cosTextL.textContent = data[0]["cosTextL"];
  
  inputsLoginForm.placeholder = data[2]["input0"];
  button.textContent = data[2]["button"];
  console.log('RecoverPassword', RecoverPassword);
  console.log('data[2]["forgot"]', data[2]["forgot"]);
  RecoverPassword.textContent = data[2]["forgot"];
  loginToAcc[0].textContent = data[2]["create"];
  if (text)
  {
    text.textContent = data[2]["text"];
  }
};


const TranslationLogOutRivo = async (data) => {        
        const lecErcle = document.querySelector('.lec-ercle');           
        const lecErcle2 = document.querySelector('.top-image__title .privilege');
  const textLogOut = document.querySelector('.rivo_TopText__p__logout');
        
          const lecErcle9 = document.querySelectorAll('.rivo_TopText_buttons__1');
  
          const lecErcle10 = document.querySelectorAll('.rivo_TopText_buttons__2'); 
  const lecErcle11 = document.querySelector('.rivo__balls__TopText h3');
          const lecErcle12 = document.querySelector('.rivo__balls__TopText p');
          const lecErcle13 = document.querySelector('.gagner__text h3');
  const lecErcle14 = document.querySelector('.gagner__text p');
  const lecErcle15 = document.querySelectorAll('.gagner__box h4');  
  const lecErcle16 = document.querySelectorAll('.gagner__box p');
  const lecErcle17 = document.querySelectorAll('.gagner__box a'); 
  const lecErcle21 = document.querySelectorAll('.image-and-text .vip-status');
  const lecErcle211 = document.querySelector('.points-0');
  const lecErcle22 = document.querySelector('.points-24');
  const lecErcle23 = document.querySelector('.points-48');
  const lecErcle24 = document.querySelector('.points-96'); 
  const lecErcle25 = document.querySelectorAll('.text.text-padding p'); 
  const rivoOut1 = document.querySelector('.rivo__balls__bottomText h3'); 

  const rivoOut2 = document.querySelector('.rivo__balls__bottomText p');
  const lecErcle30 = document.querySelector('.faq-pc-header');
  const lecErcle31 = document.querySelector('.faq-mobile-header');
  const lecErcle32 = document.querySelector('.faq__header2__p');
  const lecErcle33 = document.querySelectorAll('.akordion .accordion');
  const lecErcle34 = document.querySelectorAll('.akordion .panel p');
  const lecErcle35 = document.querySelector('.bottom-faq h5');
  const lecErcle36 = document.querySelector('.bottom-faq p');
  const lecErcle37 = document.querySelector('.bottom-faq a');
  const rivoOut3 = document.querySelector('.bottomRivoImage__div .e-slideshow__slide-heading');
  const rivoOut4 = document.querySelector('.bottomRivoImage__div .e-slideshow__slide-subheading span');
  const sliderButtons = document.querySelectorAll('.e-slideshow__slide-button a');
  
             textLogOut.innerHTML = data[9]["textLogOut"];
            lecErcle.textContent = data[3].sections[0]["0"];
            lecErcle9[0].textContent = data[9]["buttonLog"];
  lecErcle9[1].textContent = data[9]["button3"];
            lecErcle10[0].textContent = data[9]["button2"];
  lecErcle11.textContent = data[3].sections[4]["0"];
            lecErcle12.textContent = data[3].sections[4]["1"]
lecErcle13.textContent = data[3].sections[5]["0"];
lecErcle14.innerHTML = data[3].sections[5]["1"];
lecErcle15[0].textContent = data[3].sections[6]["0"];
lecErcle15[1].textContent = data[3].sections[6]["1"];
lecErcle15[2].textContent = data[3].sections[6]["2"];
lecErcle16[0].textContent = data[3].sections[7]["0"];
// lecErcle16[2].textContent = data[3].sections[7]["1"];
// lecErcle16[1].textContent = data[3].sections[7]["2"];
if (innerWidth >= 768) {
  lecErcle17[0].textContent = data[3].sections[8]["0"];
lecErcle17[1].textContent = data[3].sections[8]["1"];
lecErcle17[2].textContent = data[3].sections[8]["2"];
}
lecErcle21[0].textContent = data[3].sections[11]["vip-status1"];
lecErcle21[1].textContent = data[3].sections[11]["vip-status2"];
lecErcle21[2].textContent = data[3].sections[11]["vip-status3"];
lecErcle21[3].textContent = data[3].sections[11]["vip-status4"];
lecErcle211.textContent = data[3].sections[11]["points-1"];
lecErcle22.textContent = data[3].sections[11]["points-2"];
lecErcle23.textContent = data[3].sections[11]["points-3"];
lecErcle24.textContent = data[3].sections[11]["points-4"];
lecErcle25[0].textContent = data[3].sections[11]["text-padding1.1"];
lecErcle25[1].textContent = data[3].sections[11]["text-padding1.2"];
lecErcle25[2].textContent = data[3].sections[11]["text-padding2.1"];
  lecErcle25[3].textContent = data[3].sections[11]["text-padding2.2"];
  lecErcle25[4].textContent = data[3].sections[11]["text-padding2.3"];
  lecErcle25[5].textContent = data[3].sections[11]["text-padding2.4"];
  lecErcle25[6].textContent = data[3].sections[11]["text-padding3.1"];
  lecErcle25[7].textContent = data[3].sections[11]["text-padding3.2"];
  lecErcle25[8].textContent = data[3].sections[11]["text-padding3.3"];
  lecErcle25[9].textContent = data[3].sections[11]["text-padding3.4"];
  lecErcle25[10].textContent = data[3].sections[11]["text-padding3.5"];
  lecErcle25[11].textContent = data[3].sections[11]["text-padding3.6"];
  lecErcle25[12].textContent = data[3].sections[11]["text-padding4.1"];
  lecErcle25[13].textContent = data[3].sections[11]["text-padding4.2"];
  lecErcle25[14].textContent = data[3].sections[11]["text-padding4.3"];
  lecErcle25[15].textContent = data[3].sections[11]["text-padding4.4"];
  lecErcle25[16].textContent = data[3].sections[11]["text-padding4.5"];
  lecErcle25[17].textContent = data[3].sections[11]["text-padding4.6"];
  lecErcle25[18].textContent = data[3].sections[11]["text-padding4.7"];
  
  rivoOut1.textContent = data[9]["rivoOut1"];
  rivoOut2.textContent = data[9]["rivoOut2"];
  sliderButtons[0].textContent = data[9]["buttonLog"];
  sliderButtons[1].textContent = data[9]["button2"];
  rivoOut3.textContent = data[9]["bottomT1"];
    rivoOut4.textContent = data[9]["bottomT2"];
  
  lecErcle30.textContent = data[3].sections[15]["1"];
  lecErcle31.textContent = data[3].sections[15]["2"];
  lecErcle32.textContent = data[3].sections[15]["3"];
  lecErcle33[0].textContent = data[3].sections[15]["accordion"]["1"];
  lecErcle33[1].textContent = data[3].sections[15]["accordion"]["2"];
  lecErcle33[2].textContent = data[3].sections[15]["accordion"]["3"];
  lecErcle33[3].textContent = data[3].sections[15]["accordion"]["4"];
  lecErcle34[0].textContent = data[3].sections[15]["panel"]["1"];
  lecErcle34[1].textContent = data[3].sections[15]["panel"]["2"];
  lecErcle34[2].textContent = data[3].sections[15]["panel"]["3"];
  lecErcle34[3].textContent = data[3].sections[15]["panel"]["4"];
  lecErcle35.textContent = data[3].sections[15]["4"];
  lecErcle36.textContent = data[3].sections[15]["5"];
  lecErcle37.textContent = data[3].sections[15]["6"];
};


const TranslationLoginRivo = async (data) => {        
        const lecErcle = document.querySelector('.lec-ercle');           
        const lecErcle2 = document.querySelector('.top-image__title .privilege');
        const lecErcle3 = document.querySelector('.hello_1');      
          const lecErcle4 = document.querySelector('.hello_2');
          const lecErcle5 = document.querySelector('.vos-points'); 
          // const lecErcle6 = document.querySelector('.tab-points__text .left p');
          const lecErcle7 = document.querySelectorAll('.tab-points__text p');
          // const lecErcle8 = document.querySelector('.tab-points__text .right p');
          const lecErcle9 = document.querySelector('.rivo_TopText_buttons__1');
          const applied = document.querySelector('.popup-rivo__text-applied');
          const lecErcle10 = document.querySelector('.rivo_TopText_buttons__2'); 
          const lecErcle11 = document.querySelector('.rivo__balls__TopText h3');
          const lecErcle12 = document.querySelector('.rivo__balls__TopText p');
  
          const lecErcle13 = document.querySelector('.gagner__text h3');
  const lecErcle14 = document.querySelector('.gagner__text p');
  const lecErcle15 = document.querySelectorAll('.gagner__box h4');  
  const lecErcle16 = document.querySelectorAll('.gagner__box p');
  const lecErcle17 = document.querySelectorAll('.gagner__box a'); 
  const lecErcle18 = document.querySelectorAll('.rivo__balls .text-points p'); 
  const lecErcle188 = document.querySelectorAll('.rivo-points-balance2');
  const lecErcle19 = document.querySelector('.rivo__balls__TopText__logIN h3');
  const lecErcle20 = document.querySelector('.rivo__balls__TopText__logIN p');
  const lecErcle21 = document.querySelectorAll('.image-and-text .vip-status');
  const lecErcle211 = document.querySelector('.points-0');
  const lecErcle22 = document.querySelector('.points-24');
  const lecErcle23 = document.querySelector('.points-48');
  const lecErcle24 = document.querySelector('.points-96'); 
  const lecErcle25 = document.querySelectorAll('.text.text-padding p'); 
  const lecErcle26 = document.querySelector('#DEPENSEZ h3');
  const lecErcle27 = document.querySelector('#DEPENSEZ p');
  const lecErcle28 = document.querySelectorAll('.buttons-row button');
  const lecErcle29 = document.querySelectorAll('.complete-routine-slider__link');
  const lecErcle30 = document.querySelector('.faq-pc-header');
  const lecErcle31 = document.querySelector('.faq-mobile-header');
  const lecErcle32 = document.querySelector('.faq__header2__p');
  const lecErcle33 = document.querySelectorAll('.akordion .accordion');
  const lecErcle34 = document.querySelectorAll('.akordion .panel p');
  const lecErcle35 = document.querySelector('.bottom-faq h5');
  const lecErcle36 = document.querySelector('.bottom-faq p');
  const lecErcle37 = document.querySelector('.bottom-faq a');

  const popUp1 = document.querySelectorAll('.popup-bottom-1 p');
  const popUp2 = document.querySelector('.popup-rivo__button_add');
  const popUp3 = document.querySelector('.popup-only.popup-only2');
  const popUp4 = document.querySelector('.popup-only__name');  
  const popUp5 = document.querySelector('.popup-points2'); 
  // const popUp6 = document.querySelector('.popup-name');
  // const popUp7 = document.querySelectorAll('.popupRivo2p');
  const titleProdR = document.querySelectorAll('.complete-routine-slider__title');
  const loadR = document.querySelector('.loading-rivo');
  const popB = document.querySelector('.popup-rivo__button_redeem');
  const bApple = document.querySelector('.popup-rivo__text-apply');
  const buttonRow = document.querySelectorAll('.button-row .button');
  const accRightp = lecErcle18[1];
  
    loadR.textContent = data[3]["loadR"];
    popB.textContent = data[3]["REDEEM"];
    popUp1[1].innerHTML = data[3]["warn"];
    popUp2.textContent = data[3]["addToC"];
    popUp3.firstChild.textContent = data[3]["Roa"];
    popUp4.textContent.replace('YOUR GIFT', data[3]["YG"]);
    // popUp5.textContent.replace(' points', data[3]["points2"]);
  var currentText = popUp5.textContent;
popUp5.textContent = currentText.replace('points', data[3]["points2"]);
    console.log('popUp5', popUp5);
  console.log('data[3]["points2"]', data[3]["points2"]);
   lecErcle18[0].textContent = data[0]["accRight"];

    titleProdR.forEach((title) => {
      title.textContent.replace('YOUR GIFT', data[3]["YG"]);
    });
  if (applied) {
    applied.textContent = data[3]["Applied"];
  }
        setTimeout(()=> {
            lecErcle11.textContent = data[3].sections[4]["0"];
            lecErcle12.textContent = data[3].sections[4]["1"];          
        },5000);

  if (accRightp.textContent === '') {    
  } else if (accRightp.textContent === 'Platinum') {
    accRightp.textContent = data[0]["Platinum"];
  } else if (accRightp.textContent === 'Gold') {
    accRightp.textContent = data[0]["Gold"];
  } else if (accRightp.textContent === 'Silver') {
    accRightp.textContent = data[0]["Silver"];
  } else if (accRightp.textContent === 'Bronze') {
    accRightp.textContent = data[0]["Bronze"];
  };

            lecErcle.textContent = data[3].sections[0]["0"];
            lecErcle2.textContent = data[3].sections[0]["1"];
            lecErcle3.textContent = data[3].sections[1]["0"];
            lecErcle4.textContent = data[3].sections[1]["1"];
            lecErcle5.textContent = data[3].sections[1]["2"];
            lecErcle7[0].textContent = data[3].sections[2]["0"];
            lecErcle7[1].textContent = data[3].sections[2]["1"];
            lecErcle7[2].textContent = data[3].sections[2]["2"];
            lecErcle9.textContent = data[3].sections[3]["0"];
            lecErcle10.textContent = data[3].sections[3]["1"];
            lecErcle11.textContent = data[3].sections[4]["0"];
            lecErcle12.textContent = data[3].sections[4]["1"];
lecErcle13.textContent = data[3].sections[5]["0"];
lecErcle14.innerHTML = data[3].sections[5]["1"];
lecErcle15[0].textContent = data[3].sections[6]["0"];
lecErcle15[1].textContent = data[3].sections[6]["1"];
lecErcle15[2].textContent = data[3].sections[6]["2"];
lecErcle16[0].textContent = data[3].sections[7]["0"];
lecErcle16[2].textContent = data[3].sections[7]["1"];
lecErcle16[1].textContent = data[3].sections[7]["2"];
  if (innerWidth >= 768) {
console.log('lecErcle17[0]',lecErcle17[0]);
  console.log('test', data[3].sections[8]["0"]);
lecErcle17[0].textContent = data[3].sections[8]["0"];
  }
    // lecErcle17[1].textContent = data[3].sections[8]["1"];
// lecErcle18.textContent = data[3].sections[9]["0"];
// lecErcle18.textContent = data[3].sections[9]["1"];
  console.log('lecErcle188', lecErcle188);
  
// lecErcle18.textContent = data[3].sections[9]["2"];
lecErcle19.textContent = data[3].sections[10]["0"];
lecErcle20.textContent = data[3].sections[10]["1"];
lecErcle21[0].textContent = data[3].sections[11]["vip-status1"];
lecErcle21[1].textContent = data[3].sections[11]["vip-status2"];
lecErcle21[2].textContent = data[3].sections[11]["vip-status3"];
lecErcle21[3].textContent = data[3].sections[11]["vip-status4"];
lecErcle211.textContent = data[3].sections[11]["points-1"];
lecErcle22.textContent = data[3].sections[11]["points-2"];
lecErcle23.textContent = data[3].sections[11]["points-3"];
lecErcle24.textContent = data[3].sections[11]["points-4"];
lecErcle25[0].textContent = data[3].sections[11]["text-padding1.1"];
lecErcle25[1].textContent = data[3].sections[11]["text-padding1.2"];
lecErcle25[2].textContent = data[3].sections[11]["text-padding2.1"];
  lecErcle25[3].textContent = data[3].sections[11]["text-padding2.2"];
  lecErcle25[4].textContent = data[3].sections[11]["text-padding2.3"];
  lecErcle25[5].textContent = data[3].sections[11]["text-padding2.4"];
  lecErcle25[6].textContent = data[3].sections[11]["text-padding3.1"];
  lecErcle25[7].textContent = data[3].sections[11]["text-padding3.2"];
  lecErcle25[8].textContent = data[3].sections[11]["text-padding3.3"];
  lecErcle25[9].textContent = data[3].sections[11]["text-padding3.4"];
  lecErcle25[10].textContent = data[3].sections[11]["text-padding3.5"];
  lecErcle25[11].textContent = data[3].sections[11]["text-padding3.6"];
  lecErcle25[12].textContent = data[3].sections[11]["text-padding4.1"];
  lecErcle25[13].textContent = data[3].sections[11]["text-padding4.2"];
  lecErcle25[14].textContent = data[3].sections[11]["text-padding4.3"];
  lecErcle25[15].textContent = data[3].sections[11]["text-padding4.4"];
  lecErcle25[16].textContent = data[3].sections[11]["text-padding4.5"];
  lecErcle25[17].textContent = data[3].sections[11]["text-padding4.6"];
  lecErcle25[18].textContent = data[3].sections[11]["text-padding4.7"];
  lecErcle26.textContent = data[3].sections[12]["0"];
  lecErcle27.textContent = data[3].sections[12]["1"];
  // lecErcle28[0].textContent = data[3].sections[13]["0"];
  // lecErcle28[1].textContent = data[3].sections[13]["1"];
  // lecErcle28[2].textContent = data[3].sections[13]["2"];
  // lecErcle28[3].textContent = data[3].sections[13]["3"];
  // lecErcle29.forEach((twenty9) => {
  //   twenty9.textContent = data[3].sections[13]["complete-routine-slider__link"];
  // });  
  lecErcle30.textContent = data[3].sections[15]["1"];
  lecErcle31.textContent = data[3].sections[15]["2"];
  lecErcle32.textContent = data[3].sections[15]["3"];

  lecErcle33[0].textContent = data[3].sections[15]["accordion"]["1"];
  lecErcle33[1].textContent = data[3].sections[15]["accordion"]["2"];
  lecErcle33[2].textContent = data[3].sections[15]["accordion"]["3"];
  lecErcle33[3].textContent = data[3].sections[15]["accordion"]["4"];
  lecErcle34[0].textContent = data[3].sections[15]["panel"]["1"];
  lecErcle34[1].textContent = data[3].sections[15]["panel"]["2"];
  lecErcle34[2].textContent = data[3].sections[15]["panel"]["3"];
  lecErcle34[3].textContent = data[3].sections[15]["panel"]["4"];
  lecErcle35.textContent = data[3].sections[15]["4"];
  lecErcle36.textContent = data[3].sections[15]["5"];
  lecErcle37.textContent = data[3].sections[15]["6"];
  bApple.textContent = data[3]["REDEEM"];
  buttonRow.forEach((button) => {
    button.textContent = button.textContent.replace('POINTS', data[3]["points"]);
  });
  
    lecErcle188[0].textContent = data[3]["points"];
  
  
};

const TranslationHeaderMenu = (data) => {
  const variantsSearch = document.querySelectorAll('.search-results .productShadess');
  console.log('variantsSearch', variantsSearch);
  if (variantsSearch.length > 0) {
  variantsSearch.forEach((variant) => {
    if (variant.textContent.includes('SHADES')) {
        variant.textContent = variant.textContent.replace('SHADES', data[4]["SHADES"]);
    } else if (variant.textContent.includes('SIZES')) {
        variant.textContent = variant.textContent.replace('SIZES', data[4]["SIZES"]);
    } else {
    
    }
});

  }
  console.log('TranslationHeaderMenu');
  const headerMenu = document.querySelector('.header__menu nav');
  const navTitle = headerMenu.querySelectorAll('.site-nav__title a');  
  const links = headerMenu.querySelectorAll("a");
  let results = [];
  const headerSubTitles = headerMenu.querySelectorAll('.site-nav__subtitle a')
  const headerSubTitles2 = headerMenu.querySelectorAll('.site-nav__subtitle')
  let resultsHeaderSubTitles = []
  headerSubTitles.forEach((title) => {
    resultsHeaderSubTitles.push(title);
  });
  let resultsHeaderSubTitles2 = []
  headerSubTitles2.forEach((title) => {
    resultsHeaderSubTitles2.push(title);
  });
  const headerHelp = document.querySelectorAll('.header__help-dropdown a');
  const searchInputs = document.querySelectorAll('.search__input2');
  const readMs = document.querySelectorAll('.site-nav__slider-link');
  const headM = document.querySelectorAll('.mobile-menu__buttons a');
  const plaskaBest = document.querySelectorAll('.catalog-product__label');
  const pressbutton = document.querySelector('.press-button');
  const downLoadB = document.querySelectorAll('.press__info a');
  const reviewsCollections = document.querySelectorAll('.jdgm-prev-badge__text');
  const breadcrumbsLink =document.querySelector('.breadcrumbs__link'); 

  if (breadcrumbsLink) {
    breadcrumbsLink.textContent = data[4]["breadcrumbsLink"]
  }

  console.log('plaskaBest', plaskaBest);
  if (plaskaBest.length > 0) {
    plaskaBest.forEach((plaskaB) => {
      if (plaskaB.textContent === 'Bestsellers') {
        plaskaB.textContent = data[4]["BestS"];
      } else if (plaskaB.textContent === 'New') {
        plaskaB.textContent = data[4]["new"];
      }
      
    });
  }

    headM[0].textContent = data[4]["MobileMAcc"];
    headM[1].textContent = data[4]["MobileMWish"];
    headM[2].textContent = data[4]["MobileMCon"];
  
  readMs.forEach((readM) => {
    readM.textContent = data[4]["readM"];
  });
  
  
  navTitle[0].textContent = data[4]["women"];
  navTitle[1].textContent = data[4]["men"];
  for (let link of links) {
    if (link.textContent === "SEE ALL PRODUCTS" || link.textContent === "See all products") {
      link.textContent = data[4]["SEE ALL PRODUCTS"];
      results.push(link);
    }
  }
   resultsHeaderSubTitles.forEach((text) => {
    console.log('resultsHeaderSubTitles',text.textContent);
  });

  resultsHeaderSubTitles2.forEach((text) => {
    console.log('resultsHeaderSubTitles2',text.textContent);
  });
  
  console.log('resultsHeaderSubTitles2', resultsHeaderSubTitles2);
  resultsHeaderSubTitles[0].textContent = data[4]["BY PRODUCT CATEGORY"];
  resultsHeaderSubTitles[1].textContent = data[4]["BY SKIN NEED - WOMEN"];
  resultsHeaderSubTitles[2].textContent = data[4]["BY PRODUCT CATEGORY"];
  resultsHeaderSubTitles[3].textContent = data[4]["BY SKIN NEED - MEN"];
  resultsHeaderSubTitles[4].textContent = data[4]["SKINCARE RANGE"];
  resultsHeaderSubTitles[5].textContent = data[4]["FACE"];
  resultsHeaderSubTitles[6].textContent = data[4]["EYES"];
  resultsHeaderSubTitles[7].textContent = data[4]["LIPS"];
  resultsHeaderSubTitles[8].textContent = data[4]["PERFUMES FOR WOMEN"];
  resultsHeaderSubTitles[9].textContent = data[4]["PERFUMES FOR MEN"];
  resultsHeaderSubTitles[10].textContent = data[4]["GENDER N P"];
  resultsHeaderSubTitles[11].textContent = data[4]["FC"];
  
  resultsHeaderSubTitles2[5].textContent = data[4]["HIGHLIGHTS"];
  resultsHeaderSubTitles2[13].textContent = data[4]["HIGHLIGHTS"];
  resultsHeaderSubTitles2[15].textContent = '';
 
  resultsHeaderSubTitles2[17].textContent = data[4]["BEAUTY G"];
  resultsHeaderSubTitles2[18].textContent = data[4]["ABOUT E"];
  headerHelp[0].textContent = data[4]["help0"];
  headerHelp[1].innerHTML = data[4]["help1"];
  headerHelp[2].textContent = data[4]["help2"];

  if (innerWidth <= 1199) {
      
      const backM = document.querySelectorAll('.mobile-menu__level-return');
      const mTitle = document.querySelectorAll('.mobile-menu__spoiler-title');

      mTitle.forEach((title) => {
        console.log("title:", title.textContent);
      });

      mTitle[0].textContent = data[4]["BY PRODUCT CATEGORY"];
    mTitle[1].textContent = data[4]["BY SKIN NEED - WOMEN"];
    mTitle[2].textContent = data[4]["BY PRODUCT CATEGORY"];
    mTitle[3].textContent = data[4]["BY SKIN NEED - MEN"];
    mTitle[4].textContent = data[4]["SKINCARE RANGE"];
    mTitle[5].textContent = data[4]["HIGHLIGHTS"];
    mTitle[6].textContent = data[4]["FACE"];
    mTitle[7].textContent = data[4]["EYES"];
    mTitle[8].textContent = data[4]["LIPS"];
    mTitle[9].textContent = data[4]["HIGHLIGHTS"];
    mTitle[10].textContent = data[4]["PERFUMES FOR WOMEN"];
    mTitle[11].textContent = data[4]["PERFUMES FOR MEN"];
    mTitle[12].textContent = data[4]["GENDER N P"];
    mTitle[13].textContent = data[4]["EXTRAITS"];
    mTitle[14].textContent = data[4]["SD"];
    mTitle[15].textContent = data[6]["SCARVES"];
    if (mTitle[16]) {
    mTitle[16].textContent = data[4]["COLLECTIONS"];
    }
    if (mTitle[17]) {
    mTitle[17].textContent = data[4]["HIGHLIGHTS"];
  }
    if (mTitle[18]) {
    mTitle[18].textContent = data[4]["Special offers"];
}
    if (mTitle[19]) {
    mTitle[19].textContent = data[4]["Exclusive Services"];
}
    if (mTitle[20]) {
    mTitle[20].textContent = data[4]["ABOUT E"];
}
    if (mTitle[21]) {
    mTitle[21].textContent = data[4]["BEAUTY G"];
}
    
      backM.forEach((button) => {
        button.textContent = data[4]["mBack"];
  
      });
    }

  // shades, sizes
  const variants = document.querySelectorAll('.productShadess span');
    if (variants.length > 0) {
  variants.forEach((variant) => {
    if (variant.textContent === 'SHADES') {
      variant.textContent = data[4]["SHADES"];
    } else if (variant.textContent === 'SIZES') {
      variant.textContent = data[4]["SIZES"];
    } else {
      
    }
  });
}
  
  
  if (pressbutton) {
    pressbutton.textContent = data[4]["pressbutton"];
  }
  if (downLoadB.length > 0) {
    downLoadB.forEach((button) => {
      button.textContent = data[4]["downLoadB"];
    });
  }

  reviewsCollections.forEach((review) => {
    if (review.textContent === 'No reviews') {
      review.textContent = data[0]["noRev"];
    } else if (review.textContent.includes('reviews'))  {
      review.textContent = review.textContent.replace('reviews', data[0]["reviews"]);
    } else {
      review.textContent = review.textContent.replace('review', data[0]["review"]);
    }
  });
  
};


 
const TranslationFormButtons = (data) => {

  const fromButtons = document.querySelectorAll('button');
  
  const languageNow = document.querySelector('.header__lang-current').textContent;
  const trimmedLanguageNow = languageNow.trim();

    fromButtons.forEach((button) => {
      let trimButton = button.textContent.trim();
      if (trimButton === 'Add to cart') {
        button.textContent = data[5]["AddTC"];
      } else if (trimButton === 'Find shades') {
        button.textContent = data[5]["FS"];
      } else if (trimButton === 'Quick shop') {
        button.textContent = data[5]["QS"]; 
      } else if (trimButton === 'Available soon') {
        button.textContent = data[5]["OS"];
      }
    });
  
};

const TranslationMainPButtons = (data) => {
console.log('cookiesElements');
  const headerButtons = document.querySelector('.header-product__add-button');
  if (headerButtons) {

    let trimButton2 = headerButtons.textContent.trim();
    if (trimButton2 === 'Add to cart') {
      headerButtons.textContent = data[5]["AddTC"];
    } else if (trimButton2 === 'Out of stock') {
      headerButtons.textContent = data[5]["OS"];
    }

  }
  setTimeout(() => {
      
  const cookiesElements = document.querySelector('.product__recently-viewed-section');

if (cookiesElements) {
  const cookiesButtons = cookiesElements.querySelectorAll('button');

  cookiesButtons.forEach((button) => {
    button.textContent = data[5]["AddTC"];
    // let trimButton3 = button.textContent.trim();

    // if (trimButton3 === 'Add to Cart') {
    //   button.textContent = data[5]["AddTC"];
    // } else if (trimButton3 === 'Available soon') {
    //   button.textContent = data[5]["AS"];
    // }
  });
}
},2000);
  
const mainProductBottomButton = document.querySelector('div.product__promo2-link a');
  if (mainProductBottomButton) {
    mainProductBottomButton.textContent = data[5]["DTC"];
  }
  
};

  const TranslationMainProductReviews = (data) => {
    console.log('start');
    let jdgmLinkWrite = document.querySelector('.jdgm-write-rev-link');
    let bodyToTrans = document.querySelector('.jdgm-rev-widg__header');
     console.log('jdgmLinkWrite', jdgmLinkWrite);
    jdgmLinkWrite.textContent = data[6]['jdgmLinkWrite'];
      jdgmLinkWrite.addEventListener('click', () => {
      
    const reviewTransInterval = setInterval(() => {
      let isReadyToTrans = bodyToTrans.querySelectorAll('label');
      let readyToTrans = false;
      isReadyToTrans.forEach((label) => {
        if (label.textContent === '65+') {
          readyToTrans = true;
        }
      });
      if (readyToTrans) {
        clearInterval(reviewTransInterval);
        const customForms = document.querySelector('.jdgm-custom-forms');
        const customFormsLabels = customForms.querySelectorAll('label');
        const sliderFirst = document.querySelectorAll('.jdgm-rev__slider-first');
        const sliderLast = document.querySelectorAll('.jdgm-rev__slider-last');
        if (customForms) {
          console.log('customFormsLabels]', customFormsLabels);
          console.log('customFormsLabels[0]', customFormsLabels[0]);
          customFormsLabels[0].textContent = data[6]['l7'];
          customFormsLabels[5].textContent = data[6]['l0'];
          customFormsLabels[12].textContent = data[6]['l12'];
          customFormsLabels[13].textContent = data[6]['l13'];
          customFormsLabels[14].textContent = data[6]['l14'];
          customFormsLabels[15].textContent = data[6]['l15'];
          customFormsLabels[16].textContent = data[6]['l16'];
          customFormsLabels[17].textContent = data[6]['l17'];
          customFormsLabels[18].textContent = data[6]['l18'];
          customFormsLabels[19].textContent = data[6]['l19'];
          customFormsLabels[20].textContent = data[6]['l20'];
          customFormsLabels[21].textContent = data[6]['l21'];
          customFormsLabels[22].textContent = data[6]['l22'];
          customFormsLabels[1].textContent = data[6]['Oily'];
          customFormsLabels[2].textContent = data[6]['Combination'];
          customFormsLabels[3].textContent = data[6]['Normal'];
          customFormsLabels[4].textContent = data[6]['Dry'];
          
          sliderFirst.forEach((first) => {
            first.textContent = data[6]['first'];
          });
          sliderLast.forEach((last) => {
            last.textContent = data[6]['last'];
          });

          const lastFieldToTrans = document.querySelectorAll('.jdgm-form__fieldset')[11];
            lastFieldToTrans.querySelector('p');
            lastFieldToTrans.innerHTML = data[6]['lastField'];
          const minusGap = document.querySelectorAll('.jdgm-form__fieldset')[11];
          minusGap.style.gap = '3px';
        }
        
      }
    },300);
      });
    
    const reviewComment = document.querySelectorAll('.jdgm-rev__cf-ans__title');
    const firstSlideComm = document.querySelectorAll('.jdgm-rev__slider-first');
    const lastSlideComm = document.querySelectorAll('.jdgm-rev__slider-last');
      console.log('reviewComment', reviewComment);
    reviewComment.forEach((review) => {
      console.log('review', review);
      if (review.textContent.trim() === 'What is your age?') {
        review.textContent = data[6]['l0'];
      } else if (review.textContent.trim() === 'What is your main skin concern:') {
        review.textContent = data[6]['l12'];
      } else if (review.textContent.trim() === 'What is your skin type?') {
        review.textContent = data[6]['l7'];
      } else if (review.textContent.trim() === 'Would you recommend this product to a friend?') {
       review.textContent = data[6]['l18'];
      } else if (review.textContent.trim() === 'Age:') {
        review.textContent = data[6]['l0'];
      } else if (review.textContent.trim() === 'Skin type:') {
        review.textContent = data[6]['l7'];
      } else if (review.textContent.trim() === 'Skin concern:') {
        review.textContent = data[6]['l12'];
      } else if (review.textContent.trim() === 'Recommendation :') {
        review.textContent = data[6]['l18'];
      } else if (review.textContent.trim() === 'Efficiency:') {
        review.textContent = data[6]['l21'];
      } else if (review.textContent.trim() === 'Sensoriality:') {
        review.textContent = data[6]['l22'];
      }
    });

    if (firstSlideComm.length > 0) {
      firstSlideComm.forEach((first) => {
        first.textContent = data[6]['first'];
      });
    }

    if (lastSlideComm.length > 0) {
      lastSlideComm.forEach((last) => {
        last.textContent = data[6]['last'];
      });
    }
    
  };

  const TranslationMainProduct = (data) => {
  
  const categoryLink = document.querySelector('.product__category-link');
  console.log('categoryLink', categoryLink);
  const  categoryLinkVariants = document.querySelectorAll('.product__category-link');
  const CompletY = document.querySelector('.complete-routine-subtitle');
  const tabsButtons = document.querySelectorAll('.tabs__tab-buttons span');
  const seeIngri = document.querySelector('.tabs__tab-button-see');
    
  const exOf = document.querySelector('.product__promo1-title');
  const exOfSub = document.querySelector('.product__promo1-subtitle'); 
  const proEff = document.querySelector('.product__slider-subtitle1'); 
    const promoButton = document.querySelector('.product__promo1 a');
  const mTrioTitle = document.querySelector('.product__trio-molecular-title');
  const mTrioText = document.querySelector('.product__trio-molecular-subtitle');
  const mTrioName = document.querySelectorAll('.product__trio-molecular-name');
  const mTrioLinkOpen = document.querySelector('.product__trio-molecular-link');
  // const mTrioLinkClose = document.querySelector('.product__trio-molecular-link');
  const mTrioDesc = document.querySelectorAll('.product__trio-molecular-description');
  const idealF = document.querySelector('.product__ideal-for-title');
  const titleCo = document.querySelector('.section-subtitle');
    const mobilTabs = document.querySelectorAll('.tabs__tab-button-mobile');
    const completMobileT = document.querySelector('.product__bottom .upsellTitle');
    const rmL = document.querySelectorAll('.complete-routine-slider__link');
    const jdgmloadmore = document.querySelector('.jdgm-paginate__load-more');

     const plaskaBest = document.querySelectorAll('.catalog-product__label');
  
  if (plaskaBest.length > 0) {
    plaskaBest.forEach((plaskaB) => {
      if (plaskaB.textContent === 'Bestsellers') {
        plaskaB.textContent = data[4]["BestS"];
      } else if (plaskaB.textContent === 'New') {
        plaskaB.textContent = data[4]["new"];
      }
      
    });
  }
    
    if (seeIngri) {
      seeIngri.textContent = data[6]["seeIngri"];
    }
    if (idealF) {
      idealF.textContent = data[6]["IdealFor"];
    };

    if (exOf) {
   exOf.textContent = data[6]["exOf"];
    exOfSub.textContent = data[6]["exOfSub"]; 
    }
    if (proEff) {
    proEff.textContent = data[6]["proEff"];
    }
    if (mTrioTitle) {
    mTrioTitle.textContent = data[6]["mTrioTitle"]; 
    mTrioText.textContent = data[6]["mTrioText"]; 
    mTrioName[0].textContent = data[6]["mTrioName0"]; 
    mTrioName[1].textContent = data[6]["mTrioName1"]; 
    mTrioName[2].textContent = data[6]["mTrioName2"]; 
    mTrioLinkOpen.textContent = data[6]["mTrioLinkOpen"]; 
    mTrioDesc[0].textContent = data[6]["mTrioDesc0"]; 
    mTrioDesc[1].textContent = data[6]["mTrioDesc1"]; 
    mTrioDesc[2].textContent = data[6]["mTrioDesc2"];
    }

    if (promoButton) {
    promoButton.textContent = data[4]["RM"];
    }
    
    if (categoryLinkVariants.length > 1 ) {     
      console.log('categoryLinkVariants[0]', categoryLinkVariants[0]);
       console.log('categoryLinkVariants[1]', categoryLinkVariants[1]);
        categoryLinkVariants[1].textContent = categoryLinkVariants[0].textContent;
      }

    
    console.log('categoryLinkVariants', categoryLinkVariants);
    if (categoryLink.textContent === 'SKINCARE') {
      categoryLink.textContent = data[6]["SKINCARE"];
    } else if (categoryLink.textContent === 'PERFUMES') {
      categoryLink.textContent = data[6]["PERFUMES"]; 
      if (categoryLinkVariants.length > 1 ) {
        
        categoryLinkVariants.forEach((link) => {
          link.textContent = data[6]["PERFUMES"]; 
        });
      }
    } else if (categoryLink.textContent === 'MAKEUP') {
      categoryLink.textContent = data[6]["MAKE-UP"]; 
      
    } else if (categoryLink.textContent === 'DEODORANTS') {
      categoryLink.textContent = data[6]["DEODORANTS"]; 
      if (categoryLinkVariants.length > 1 ) {
        categoryLinkVariants.forEach((link) => {
          link.textContent = data[6]["DEODORANTSP"]; 
        });
      }
    } else if (categoryLink.textContent === 'SCARVES') {
      categoryLink.textContent = data[6]["SCARVES"]; 
    } else if (categoryLink.textContent === 'SKINCARE ROUTINES') {
      categoryLink.textContent = data[6]["SR"]; 
    }
  console.log('categoryLink.textContent', categoryLink.textContent);
    if (categoryLink.textContent === 'ÉCHARPES' ) {
                categoryLink.textContent = 'FOULARDS';
    }
console.log('categoryLinkVariants2', categoryLinkVariants);
    tabsButtons.forEach((tab) => {
      if (tab.textContent.trim() === 'Key actions') {
        tab.textContent = data[6]["Key actions"];
      } else if (tab.textContent.trim() === 'benefits') {
        tab.textContent = data[6]["benefits"];
      } else if (tab.textContent.trim() === 'ingredients') {
        tab.textContent = data[6]["ingredients"];
      } else if (tab.textContent.trim() === 'Application Tips') {
        tab.textContent = data[6]["Application Tips"];
      } else if (tab.textContent.trim() === 'Olfactory pyramid') {
        tab.textContent = data[6]["Olfactory pyramid"];
      } else if (tab.textContent.trim() === 'Description') {
        tab.textContent = data[6]["Description"]; 
      } else if (tab.textContent.trim() === 'story') {
        tab.textContent = data[6]["story"];
      }
      
      
    });

    tabsButtons.forEach((tab) => {
      if (tab.textContent.trim() === "CONSEILS D'APPLICATION") {
        tab.textContent = "CONSEILS";
      }
      });

    if (jdgmloadmore) {
    jdgmloadmore.textContent = data[11]["LM"];

    jdgmloadmore.addEventListener('click', () => {
     setInterval(() => {
       const newjdgmloadmore = document.querySelector('.jdgm-paginate__load-more');
       if (newjdgmloadmore) {
         newjdgmloadmore.textContent = data[11]["LM"];
       }
     },500);
    });
    }
    titleCo.textContent = data[6]["titleCo"];

    console.log('CompletY', CompletY);
    if (CompletY) {
    CompletY.textContent = data[6]["CompletY"];
    rmL.forEach((rmLs) => {
      rmLs.textContent = data[4]["readM"];
    });
    }
    
 mobilTabs.forEach((mTab) => {
  if (mTab.textContent.trim() === 'Key actions') {
        mTab.textContent = data[6]["Key actions"];
      } else if (mTab.textContent.trim() === 'benefits') {
        mTab.textContent = data[6]["benefits"];
      } else if (mTab.textContent.trim() === 'ingredients') {
        mTab.textContent = data[6]["ingredients"];
      } else if (mTab.textContent.trim() === 'Application Tips') {
        mTab.textContent = data[6]["Application Tips"];
      } else if (mTab.textContent.trim() === 'Olfactory pyramid') {
        mTab.textContent = data[6]["Olfactory pyramid"];
      } else if (mTab.textContent.trim() === 'Description') {
        mTab.textContent = data[6]["Description"]; 
      } else if (mTab.textContent.trim() === 'Story') {
        mTab.textContent = data[6]["story"];
      }
 });
    completMobileT.textContent = data[8]["mComplet"];
    mobilTabs.forEach((mTab) => {
  if (mTab.textContent.trim() === 'INGRÉDIENTS') {
        mTab.textContent = 'Composition';
      } else if (mTab.textContent.trim() === "CONSEILS D'APPLICATION") {
        mTab.textContent = 'CONSEILS';
      } 
 });
  };

const TranslationFooter = (data) => {
  
  const footerEBen = document.querySelector('.footer__benefits-title');
  const footerDesc = document.querySelectorAll('.footer__benefit-description');
  const footerChoo = document.querySelector('.footer__lang-current');
  const footerSub = document.querySelector('.footer__middle-center-header');
  const footerFol = document.querySelector('.footer__follow-us-title');
  const footerSubB = document.querySelector('.footer-email-form__submit');
  const footerInput = document.querySelector('.footer-email-form__input');
  const noteSuccess = document.querySelectorAll('.note--success');
  const footerLangSelectC = document.querySelectorAll('.footerLangSelectText_C');
  const footerLangSelectL = document.querySelectorAll('.footerLangSelectText_L');

  console.log('noteSuccess', noteSuccess);
  if (noteSuccess.length > 0) {
    noteSuccess.forEach((mess) => {
      mess.textContent = data[7]["succesMess"];
    });
  }

  footerEBen.textContent = data[7]["benefits"];
  footerDesc[0].innerHTML = data[7]["footerDesc0"];
  footerDesc[1].innerHTML = data[7]["footerDesc1"];
  footerDesc[2].innerHTML = data[7]["footerDesc2"];
  footerDesc[3].innerHTML = data[7]["footerDesc3"];
  if (footerChoo) {
    footerChoo.textContent = data[7]["footerChoo"];
  }
  footerSub.textContent = data[7]["footerSub"];
  footerFol.textContent = data[7]["footerFol"];
  if (footerSubB) {
    footerSubB.textContent = data[7]["button"];
  }
  if (footerInput) {
    footerInput.placeholder = data[7]["email"];
  }
footerLangSelectC.forEach((trans) => {
  trans.textContent = data[7]["country"];
});

  footerLangSelectL.forEach((trans) => {
  trans.textContent = data[7]["language"];
});

  // USD store: EU rollback disabled
  // footerDesc[0].innerHTML = footerDesc[0].innerHTML.replace('$250', '149€');
  
  // footerDesc[1].innerHTML = footerDesc[1].innerHTML.replace('$200', '200€');
  // footerDesc[2].innerHTML = footerDesc[2].innerHTML.replace('$250', '149€');
  // footerDesc[3].innerHTML = footerDesc[3].innerHTML.replace('$250', '149€');
};

const TranslationRecover = (data) => {
  const buttonR = document.querySelector('.button_formResetPass');
  const pageName = document.querySelector('.banner__box span');
  
  buttonR.textContent = data[0]["changP"];
  pageName.textContent = data[0]["topt"];
};


const TranslationReset = (data) => {
  
  const pageName = document.querySelector('.top-image__title');
  const labels = document.querySelectorAll('form .field p');

  labels[0].textContent = data[0]["newp"];
  labels[1].textContent = data[0]["cp"];
  pageName.textContent = data[0]["topt"];
  
};


const fetchJSON = async (url) => {
  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

const deletePreloader = () => {
              const preloaderExit = document.querySelector('.preloader');
                    if (preloaderExit) {
                      
                    preloaderExit.classList.add("hide-preloader");
                      let htmlElement = document.documentElement; 
                htmlElement.style.overflow = "auto";
                    }
              }


document.addEventListener("DOMContentLoaded", async () => {
    setTimeout(async () => {
      // const languageNow = document.querySelector('.header__lang-current').textContent;
      // const trimmedLanguageNow = languageNow.trim();
  
  var currentURL = window.location.href;
  var parts = currentURL.split('/');
  var trimmedLanguageNow = parts[3].slice(0,2); 
  console.log('trimmedLanguageNow123', trimmedLanguageNow);
  
  
  
      switch (trimmedLanguageNow) {
        case 'fr':
         
            try {
              const data = await fetchJSON('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/FR_Roman_product_block_exclusive_offers.json?v=1721974811');
              TranslationFormButtons(data);
              TranslationHeaderMenu(data);
              TranslationMainPButtons(data);
              TranslationNewsletter(data);
              console.log('window.location.pathname.includes', window.location.pathname);
              if (window.location.pathname.includes('/account/addresses'))  {
                TranslationAddress(data);
              }
              if (window.location.pathname.includes('/account/activate'))  {
                TransActivate(data);
              }
              if (window.location.pathname.includes('/search')) {
              TranslationSearch(data);
              }
              if (window.location.pathname.includes('/products/')) {
                TranslationMainProduct(data);
                
                const productCLFr = document.querySelector('.product__category-link');
                console.log('productCLFr', productCLFr);
                if (productCLFr.textContent === 'ÉCHARPES' ) {
                  console.log('productCLFr2', productCLFr);
                
                const tabsButtons2 = document.querySelectorAll('.tabs__tab-buttons span');

                tabsButtons2.forEach((tab2) => {
                  if (tab2.textContent.trim() === "CONSEILS D'APPLICATION") {
                    console.log('productCLFr3', productCLFr);
                    tab2.textContent = 'CONSEILS';
                  }
                });
                }
                
                console.log('teest'); TranslationMainProductReviews(data);   TranslationReviewInMP(data);
              }
              if (window.location.pathname.includes('/collections/')) {
                TranslationCollection(data);
              }
              if (window.location.pathname.includes('/account/reset')) {
                TranslationReset(data);
              }            
              if (window.location.pathname.includes('/account/register')) {
                
                  
                        TranslationRegisterForm(data);
                        deletePreloader();
              
            
              }
             else if (window.location.pathname.includes('/account/login')) {
                TranslationLoginForm(data);
              } else if (window.location.pathname.includes('/account')) {
               TranslationAddress(data);
               const checkLoad = document.querySelector('.cf-react-target');
                const performTranslation = () => {
                    const checkLoadAgain = document.querySelector('.cf-react-target');
                    if (checkLoadAgain) {
                        TranslationAccount(data);
                        deletePreloader();
                    } else {
                        setTimeout(performTranslation, 2500);
                    }
                };
            
                if (checkLoad) {
                    TranslationAccount(data);
                    deletePreloader();
                } else {
                    setTimeout(() => {
                        performTranslation();
                    }, 1500);
                }             
              } else if (window.location.pathname.includes('/pages/contact')) {
               TranslationContactPage(data);
              } else if (window.location.pathname.includes('/pages/cercle-privilege')) {
                TranslationLoginRivo(data);
              } else if (window.location.pathname.includes('/pages/your-orders')) {
                TranslationMyOrders(data);
              } else if (window.location.pathname.includes('/pages/wishlist')) {
                
                TranslationWishlist(data);
              } else if (window.location.pathname.includes('/account/addresses')) {
               console.log('add1');
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/addresses')) {
                console.log('add11');
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/pages/exclusive-services-cercle-privilege')) {
                TranslationLogOutRivo(data);
              } else if (window.location.pathname.includes('/pages/recover-password')) {
               TranslationRecover(data);
              }
             TranslationFooter(data);
            } catch (error) {
              console.error('Error processing language data:', error);
            }
          
          break;
        case 'de':
  
            try {
              const data = await fetchJSON('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/DE_Roman_19.07.json?v=1721396745');
              TranslationFormButtons(data);
              TranslationHeaderMenu(data);
              TranslationMainPButtons(data);
              TranslationNewsletter(data);
              if (window.location.pathname.includes('/account/addresses'))  {
                TranslationAddress(data);
              }
              if (window.location.pathname.includes('/account/activate'))  {
                TransActivate(data);
              }
              if (window.location.pathname.includes('/search')) {
              TranslationSearch(data);
              }
              if (window.location.pathname.includes('/products/')) {
                TranslationMainProduct(data);
                TranslationMainProductReviews(data);
              }
              if (window.location.pathname.includes('/collections/')) {
                TranslationCollection(data);
              }
              if (window.location.pathname.includes('/account/reset')) {
                TranslationReset(data);
              } 
              if (window.location.pathname.includes('/account/register')) {
                                  
                        TranslationRegisterForm(data);
                        deletePreloader();
                   
              }
             else if (window.location.pathname.includes('/account/login')) {
                TranslationLoginForm(data);
              } else if (window.location.pathname.includes('/account')) {
               TranslationAddress(data);
               const checkLoad = document.querySelector('.cf-react-target');
                const performTranslation = () => {
                    const checkLoadAgain = document.querySelector('.cf-react-target');
                    if (checkLoadAgain) {
                        TranslationAccount(data);
                        deletePreloader();
                    } else {
                        setTimeout(performTranslation, 2500);
                    }
                };
            
                if (checkLoad) {
                    TranslationAccount(data);
                    deletePreloader();
                } else {
                    setTimeout(() => {
                        performTranslation();
                    }, 1500);
                }             
              } else if (window.location.pathname.includes('/pages/contact')) {
               TranslationContactPage(data);
              } else if (window.location.pathname.includes('/pages/cercle-privilege')) {
                TranslationLoginRivo(data);
              } else if (window.location.pathname.includes('/pages/your-orders')) {
                TranslationMyOrders(data);
              } else if (window.location.pathname.includes('/pages/wishlist')) {
              
                TranslationWishlist(data);
              } else if (window.location.pathname.includes('/account/addresses/')) {
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/pages/exclusive-services-cercle-privilege')) {
                TranslationLogOutRivo(data);
              } else if (window.location.pathname.includes('/pages/recover-password')) {
               TranslationRecover(data);
              }
             TranslationFooter(data);
            } catch (error) {
              console.error('Error processing language data:', error);
            }
          
          break;
        case 'it':
  
            try {
              const data = await fetchJSON('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/it_22_05_Alex_5a333c87-c0a7-49d4-9c08-97bc69ebc97c.json?v=1716412933');
              TranslationFormButtons(data);
              TranslationHeaderMenu(data);
              TranslationMainPButtons(data);
              TranslationNewsletter(data);
              if (window.location.pathname.includes('/search')) {
              TranslationSearch(data);
              }
              if (window.location.pathname.includes('/account/activate'))  {
                TransActivate(data);
              }
              if (window.location.pathname.includes('/products/')) {
                TranslationMainProduct(data);
                TranslationMainProductReviews(data);
              }
              if (window.location.pathname.includes('/collections/')) {
                TranslationCollection(data);
              }
              if (window.location.pathname.includes('/account/reset')) {
                TranslationReset(data);
              } 
              if (window.location.pathname.includes('/account/register')) {
             
                        TranslationRegisterForm(data);
                        deletePreloader();
  
              }
             else if (window.location.pathname.includes('/account/login')) {
                TranslationLoginForm(data);
              } else if (window.location.pathname.includes('/account')) {
               TranslationAddress(data);
               const checkLoad = document.querySelector('.cf-react-target');
                const performTranslation = () => {
                    const checkLoadAgain = document.querySelector('.cf-react-target');
                    if (checkLoadAgain) {
                        TranslationAccount(data);
                        deletePreloader();
                    } else {
                        setTimeout(performTranslation, 2500);
                    }
                };
            
                if (checkLoad) {
                    TranslationAccount(data);
                    deletePreloader();
                } else {
                    setTimeout(() => {
                        performTranslation();
                    }, 1500);
                }             
              } else if (window.location.pathname.includes('/pages/contact')) {
               TranslationContactPage(data);
              } else if (window.location.pathname.includes('/pages/cercle-privilege')) {
                TranslationLoginRivo(data);
              } else if (window.location.pathname.includes('/pages/your-orders')) {
                TranslationMyOrders(data);
              } else if (window.location.pathname.includes('/pages/wishlist')) {
               
                TranslationWishlist(data);
              } else if (window.location.pathname.includes('/account/addresses/')) {
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/pages/exclusive-services-cercle-privilege')) {
                TranslationLogOutRivo(data);
              } else if (window.location.pathname.includes('/pages/recover-password')) {
               TranslationRecover(data);
              }
             TranslationFooter(data);
            } catch (error) {
              console.error('Error processing language data:', error);
            }
          
          break;
        case 'ru':
    console.log('aaaaaaaa1');
            try {
              console.log('aaaaaaaa2');
              const data = await fetchJSON('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/ru_22_05_Alex_59058857-d561-4c83-a7cc-a691d1111f85.json?v=1716412933');
              TranslationFormButtons(data);
              TranslationHeaderMenu(data);
              TranslationMainPButtons(data);
              TranslationNewsletter(data);
              console.log('aaaaaaaa3');
              if (window.location.pathname.includes('/search')) {
              TranslationSearch(data);
              }
              if (window.location.pathname.includes('/account/activate'))  {
                TransActivate(data);
              }
              if (window.location.pathname.includes('/products/')) {
                TranslationMainProduct(data);
                TranslationMainProductReviews(data);
              } 
              if (window.location.pathname.includes('/collections/')) {
                TranslationCollection(data);
              }
              if (window.location.pathname.includes('/account/reset')) {
                TranslationReset(data);
              } 
              if (window.location.pathname.includes('/account/register')) {
           
                        TranslationRegisterForm(data);
                        deletePreloader();
  
              }
             else if (window.location.pathname.includes('/account/login')) {
                TranslationLoginForm(data);
              } else if (window.location.pathname.includes('/account')) {
               TranslationAddress(data);
               console.log('aaaaaaaa4');
               console.log('testRu - account');
             
               const checkLoad = document.querySelector('.cf-react-target');
                const performTranslation = () => {
                    const checkLoadAgain = document.querySelector('.cf-react-target');
                    if (checkLoadAgain) {
                        TranslationAccount(data);
                        deletePreloader();
                    } else {
                        setTimeout(performTranslation, 2500);
                    }
                };
            
                if (checkLoad) {
                    TranslationAccount(data);
                    deletePreloader();
                } else {
                    setTimeout(() => {
                        performTranslation();
                    }, 1500);
                }             
              } else if (window.location.pathname.includes('/pages/contact')) {
               TranslationContactPage(data);
              } else if (window.location.pathname.includes('/pages/cercle-privilege')) {
                TranslationLoginRivo(data);
              } else if (window.location.pathname.includes('/pages/your-orders')) {
                TranslationMyOrders(data);
              } else if (window.location.pathname.includes('/pages/wishlist')) {
               
                TranslationWishlist(data);
              } else if (window.location.pathname.includes('/account/addresses/')) {
               console.log('aaaaaaaa -- addresses');
                TranslationAddress(data);
              } else if (window.location.pathname.includes('addresses')) {
               console.log('aaaaaaaa -- addresses');
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/pages/exclusive-services-cercle-privilege')) {
                TranslationLogOutRivo(data);
              } else if (window.location.pathname.includes('/pages/recover-password')) {
               TranslationRecover(data);
              }
             TranslationFooter(data);
            } catch (error) {
              console.error('Error processing language data:', error);
            }
          
          break;
        case 'zh':
  
            try {
              const data = await fetchJSON('https://cdn.shopify.com/s/files/1/0665/2798/5877/files/cn_22_05_Alex_57d4bc7f-1f2b-4fb5-9676-335ef1c59eb5.json?v=1716412934');
              TranslationFormButtons(data);
              TranslationHeaderMenu(data);
              TranslationMainPButtons(data);
              TranslationNewsletter(data); 
              if (window.location.pathname.includes('/account/addresses'))  {
                TranslationAddress(data);
              }
              if (window.location.pathname.includes('/account/activate'))  {
                TransActivate(data);
              }
              if (window.location.pathname.includes('/search')) {
              TranslationSearch(data);
              }
              if (window.location.pathname.includes('/products/')) {
                TranslationMainProduct(data);
                TranslationMainProductReviews(data);
              }
              if (window.location.pathname.includes('/collections/')) {
                TranslationCollection(data);
              }
              if (window.location.pathname.includes('/account/reset')) {
                TranslationReset(data);
              } 
              if (window.location.pathname.includes('/account/register')) {
              
                        TranslationRegisterForm(data);
                        deletePreloader();
                    
              }
             else if (window.location.pathname.includes('/account/login')) {
                TranslationLoginForm(data);
              } else if (window.location.pathname.includes('/account')) {
               TranslationAddress(data);
               const checkLoad = document.querySelector('.cf-react-target');
                const performTranslation = () => {
                    const checkLoadAgain = document.querySelector('.cf-react-target');
                    if (checkLoadAgain) {
                        TranslationAccount(data);
                        deletePreloader();
                    } else {
                        setTimeout(performTranslation, 2500);
                    }
                };
            
                if (checkLoad) {
                    TranslationAccount(data);
                    deletePreloader();
                } else {
                    setTimeout(() => {
                        performTranslation();
                    }, 1500);
                }             
              } else if (window.location.pathname.includes('/pages/contact')) {
               TranslationContactPage(data);
              } else if (window.location.pathname.includes('/pages/cercle-privilege')) {
                TranslationLoginRivo(data);
              } else if (window.location.pathname.includes('/pages/your-orders')) {
                TranslationMyOrders(data);
              } else if (window.location.pathname.includes('/pages/wishlist')) {
               
                TranslationWishlist(data);
              } else if (window.location.pathname.includes('/account/addresses/')) {
               console.log('asddddddddd');
                TranslationAddress(data);
              } else if (window.location.pathname.includes('/pages/exclusive-services-cercle-privilege')) {
                TranslationLogOutRivo(data);
              } else if (window.location.pathname.includes('/pages/recover-password')) {
               TranslationRecover(data);
              }
             TranslationFooter(data);
            } catch (error) {
              console.error('Error processing language data:', error);
            }
          
          break;
          default:
            window.addEventListener("load", function() {
              const preloader = document.querySelector(".preloader");
              if (window.location.pathname.includes('/account') || window.location.pathname.includes('/account/register')) {
                preloader.classList.add("hide-preloader");
                let htmlElement = document.documentElement; 
                htmlElement.style.overflow = "auto";
                
                setTimeout(() => {
                  const preloader2 = document.querySelector(".preloader");
                  preloader2.classList.add("hide-preloader");
                  let htmlElement2 = document.documentElement; 
                  htmlElement2.style.overflow = "auto";
                },3300);
              }
             const cookiesInterval = setInterval(() => {
                const cookiesElements = document.querySelector('.product__recently-viewed-section');
                  if (cookiesElements) {
                    
                    const cookiesButtons = cookiesElements.querySelectorAll('button');
                    cookiesButtons.forEach((button) => {
                     button.textContent = 'Add to cart';
                    });
                    clearInterval(cookiesInterval);
                  }
              },500);
           
              cookiesButtonT();
            }); 
            break;
          
      }
    }, 500);

  });

